namespace $.$$ {

	$mol_style_define( $shm_dashboard_admin_book, {
		position: 'absolute',
		inset: '0',
		width: '100%',
		height: '100%',
		minWidth: 0,
		minHeight: 0,
		maxHeight: '100%',
		overflow: 'auto',

		Navigation: {
			flexDirection: 'column',
			gap: 0,
		},

		Menu_session: {
			width: '100%',
			maxWidth: '100%',
			minWidth: 0,
			overflow: 'hidden',
			flexDirection: 'column',
			alignItems: 'stretch',
			gap: $mol_gap.text,
		},

		Dashboard_link: {
			width: '100%',
			maxWidth: '100%',
			minWidth: 0,
			padding: $mol_gap.text,
			overflow: 'hidden',
			whiteSpace: 'nowrap',
			textOverflow: 'ellipsis',
		},

		Superuser: {
			minWidth: 0,
			padding: $mol_gap.text,
			color: $mol_theme.current,
			wordBreak: 'break-word',
			userSelect: 'text',
		},

		Logout: {
			alignSelf: 'flex-start',
		},

		Menu: {
			width: '16rem',
			maxWidth: '16rem',
			minWidth: 0,
			flex: { basis: '16rem', grow: 0, shrink: 0 },

			Foot: {
				minWidth: 0,
				overflow: 'hidden',
				padding: $mol_gap.block,
				flexDirection: 'column',
				gap: $mol_gap.block,
			},
		},
	} )

}
